// istanbul ignore file

export enum ActiveNoticePropertyTag {
    Cancelled = 'CANCELLED',
    OutstandingInvoices = 'OUTSTANDING_INVOICES',
    SaferHomePackage = 'SAFER_HOME_PACKAGE',
    OverdueInvoices = 'OVERDUE_INVOICES',
    Integrated = 'INTEGRATED',
    PAYGBilling = 'PAYG_BILLING',
    SubscriptionBilling = 'SUBSCRIPTION_BILLING',
    BetweenTenancyTracking = 'BETWEEN_TENANCY_TRACKING',
    ExternalActiveNotices = 'EXTERNAL_ACTIVE_NOTICES',
    LeaseAgreementUpdateRequired = 'LEASE_AGREEMENT_UPDATE_REQUIRED',
    LegislationUpgradePending = 'LEGISLATION_UPGRADE_PENDING',
    Overdue = 'OVERDUE',
    NotOverdue = 'NOT_OVERDUE',
    PriorityBooking = 'PRIORITY_BOOKING',
    Vacant = 'VACANT',
    OnHold = 'ON_HOLD'
}

export enum ActiveNoticeFacets {
    Overdue = 'OVERDUE',
    NotOverdue = 'NOT_OVERDUE',
    PriorityBooking = 'PRIORITY_BOOKING',
    Vacant = 'VACANT',
    OnHold = 'ON_HOLD',
    UpdateRequired = 'UPDATE_REQUIRED'
}
